import { MessageInterface, MessageType } from '../_model/message/message.model';
import { Injectable } from "@angular/core";
import { Resource } from 'app/_service/resource/resource';

@Injectable()
export class MessageTransFormer 
{
    transform(message): MessageInterface 
    {
        return {
            id: message.id,
            timestamp: message.postTime,
            type: message.messageType,
            content: message.context,
            cid: message.cid,
            user: {
                id: message.uid,
                name: message.title,
                avatar: message.headImage,
                role: this.getUserRoleFromImage(message.userLevelPic),
                level: message.userCurrentLevel,
                isOfficalUp: message.isOfficalUP,
                userLevelSymbol: Resource.getGIDResource(message.gid) || Resource.getGIDResource(this.getGIDFromImage(message.userLevelPic)),
                gid: message.gid,
                userKey: message.userKey,
            },
            video: {
                title: message.videoName,
                key: message.videoUrl,
                vid: message.vid,
            },
            comment: {
                id: message.id,
                likes: message.hit,
                isLike: message.isLike,
                reply: {
                    title: message.toTitle,
                    content: message.replyContent,
                },
                voteId: message.voteId,
            }
        };
    }

    getUserRoleFromImage(imagePath)
     {
        if (!imagePath) {
            return '';
        }
        
        switch (true) {
            case imagePath.indexOf('royal-vvvip.png') !== -1:
                return 'royalVip';
            case imagePath.indexOf('royal-admin.png') !== -1:
                return 'royalAdmin';
            case imagePath.indexOf('normal-vip.png') !== -1:
                return 'vip';
            case imagePath.indexOf('g-VIP.png') !== -1:
                return 'gvip';
            case imagePath.indexOf('et-VIP.png') !== -1:
                return 'etvip';
            case imagePath.indexOf('cpvip.png') !== -1:
                return 'cpvip';
            case imagePath.indexOf('editor.png') !== -1:
                return 'editor';
            default:
                return '';
        }
    }

    getGIDFromImage(imagePath)
    {
       if (!imagePath) {
           return 0;
       }
       
       switch (true) {
           case imagePath.indexOf('royal-vvvip.png') !== -1:
               return 3;
           case imagePath.indexOf('royal-admin.png') !== -1:
               return 102;
           case imagePath.indexOf('normal-vip.png') !== -1:
               return 0;
           case imagePath.indexOf('g-VIP.png') !== -1:
               return 1;
           case imagePath.indexOf('et-VIP.png') !== -1:
               return 2;
           case imagePath.indexOf('cpvip.png') !== -1:
               return 4;
           case imagePath.indexOf('editor.png') !== -1:
               return 101;
           default:
               return '';
       }
   }
}
